import Form, { IChangeEvent, withTheme } from "@rjsf/core";
// import { withTheme } from '@rjsf/core';
import { Theme as ChakraUITheme } from "@rjsf/chakra-ui";
import {
  ErrorTransformer,
  FieldErrorProps,
  RegistryFieldsType,
  RegistryWidgetsType,
  RJSFSchema,
  UiSchema,
} from "@rjsf/utils";
import validator from "@rjsf/validator-ajv8";
// import Spinner from '@salesforce/design-system-react/components/spinner';
import React, { useState } from "react";
import fields from "./theme/fields/Fields";
import templates from "./theme/templates/Templates";
import widgets from "./theme/widgets/Widgets";
import { ThemeProps } from "@rjsf/core";

// const theme: ThemeProps = {
//   templates: templates,
//   fields: fields,
//   widgets: widgets,
// };
const combinedWidgets: RegistryWidgetsType = {
  ...widgets,
  ...ChakraUITheme.widgets,
};
ChakraUITheme.widgets = combinedWidgets;
export const SLDSForm = withTheme(ChakraUITheme);

interface FormProps {
  id?: string;
  schema: RJSFSchema;
  uiSchema?: UiSchema;
  formData?: any;
  customFields?: RegistryFieldsType<any, any>;
  customWidgets?: RegistryWidgetsType;
  spinnerSize?: "small" | "medium";
  spinnerOpacity?: number;
  onSubmit?:
    | ((data: IChangeEvent<any, any>, event: React.FormEvent<any>) => void)
    | undefined;
  onChange?:
    | ((data: IChangeEvent<any, any>, id?: string | undefined) => void)
    | undefined;
  isLoading?: boolean;
}

export const transformErrors: ErrorTransformer = (errors) => {
  return errors.map((error) => {
    if (error.name === "required") {
      const stack = error.schemaPath
        ?.replace(/(^#)/, "")
        .replace(/(\/required$)/, "")
        .split("/properties/");

      error.message = "This field is required";
      error.property =
        stack?.join(".") + "." + error.params?.missingProperty || "";
    }
    return error;
  });
};

export const SLDSFormNew = React.forwardRef<
  Form<any, RJSFSchema, any>,
  FormProps
>(
  (
    {
      schema,
      uiSchema,
      customWidgets,
      onSubmit,
      id,
      isLoading,
      spinnerSize,
      spinnerOpacity,
      formData,
      onChange,
    },
    ref
  ) => {
    const [isFormLoading, setIsFormLoading] = useState<Record<string, boolean>>(
      {}
    );

    return (
      <div className="slds-is-relative">
        {isLoading ||
        Object.entries(isFormLoading).reduce(
          (prev, [key, value]) => prev && value,
          false
        ) ? (
          <div
            style={{
              position: "absolute",
              height: "100%",
              right: "0",
              left: "0",
            }}
          >
            {/* <Spinner
              containerStyle={{
                background: `rgba(255,255,255,${spinnerOpacity || 1})`
              }}
              size={spinnerSize || 'medium'}
              variant="brand"
              assistiveText={{ label: 'Main Frame Loading...' }}
            /> */}
          </div>
        ) : null}
        <SLDSForm
          id={id}
          schema={schema}
          uiSchema={uiSchema}
          validator={validator}
          onSubmit={onSubmit}
          onChange={onChange}
          formData={formData}
          // templates={{ FieldErrorTemplate }}
          showErrorList={false}
          transformErrors={transformErrors}
          formContext={{
            isFormLoading: isFormLoading,
            setIsFormLoading: setIsFormLoading,
          }}
          ref={ref}
          noHtml5Validate
          omitExtraData
          liveOmit

          // liveValidate
        />
      </div>
    );
  }
);
